import { CommonModule } from "@angular/common";
import {
	AfterContentInit,
	Component,
	ContentChildren,
	QueryList,
	TemplateRef
} from "@angular/core";
import { AutomataTemplateDirective } from "@shared/directives/automata-template.directive";

@Component({
	selector: "app-card",
	templateUrl: "./card.component.html",
	styleUrls: ["./card.component.scss"],
	imports: [CommonModule]
})
export class CardComponent implements AfterContentInit {
	@ContentChildren(AutomataTemplateDirective)
	private templates!: QueryList<AutomataTemplateDirective>;

	protected cardHeader!: TemplateRef<unknown>;
	protected cardBody!: TemplateRef<unknown>;

	ngAfterContentInit(): void {
		this.setCustomTemplates();
	}

	private setCustomTemplates(): void {
		this.templates.forEach((item) => {
			switch (item.getType()) {
				case "cardHeader":
					this.cardHeader = item.template;
					break;
				case "cardBody":
					this.cardBody = item.template;
					break;
			}
		});
	}
}
